import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _def690ca = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _4eae939c = () => interopDefault(import('..\\pages\\rejection.vue' /* webpackChunkName: "pages_rejection" */))
const _241a8f7e = () => interopDefault(import('..\\pages\\unlock.vue' /* webpackChunkName: "pages_unlock" */))
const _12af407e = () => interopDefault(import('..\\pages\\upload.vue' /* webpackChunkName: "pages_upload" */))
const _dc9ae408 = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _dc7eb506 = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _dc465702 = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _dc2a2800 = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _72ce6d86 = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _4cbe9965 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/error",
    component: _def690ca,
    name: "error"
  }, {
    path: "/rejection",
    component: _4eae939c,
    name: "rejection"
  }, {
    path: "/unlock",
    component: _241a8f7e,
    name: "unlock"
  }, {
    path: "/upload",
    component: _12af407e,
    name: "upload"
  }, {
    path: "/errors/400",
    component: _dc9ae408,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _dc7eb506,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _dc465702,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _dc2a2800,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _72ce6d86,
    name: "errors-500"
  }, {
    path: "/",
    component: _4cbe9965,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
